import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
const prospectingCompaniesUrl = '/api/lusha-prospecting/companies';
const searchCompaniesByName = (companyData) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post(prospectingCompaniesUrl, companyData); });
const prospectingEmployeesUrl = '/api/lusha-prospecting/employees';
const searchEmployeesByCompany = (companyData) => __awaiter(void 0, void 0, void 0, function* () { return AjaxUtils.post(prospectingEmployeesUrl, companyData); });
export { searchCompaniesByName, searchEmployeesByCompany };
